import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { boolean, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { softDelete } from '../columns/soft-delete';

export const albums = pgTable('albums', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  title: text('title').notNull(),
  description: text('description'),
  coverImage: text('cover_image'),
  // Só os álbuns públicos aparecem na galeria do site (`GET /public/albums`).
  isPublic: boolean('is_public').notNull().default(false),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
  ...softDelete,
});

export type Album = InferSelectModel<typeof albums>;
export type CreateAlbumInput = InferInsertModel<typeof albums>;
export type UpdateAlbumInput = Partial<CreateAlbumInput>;
